import lodash from 'lodash';
import {
    queryGraphQL,
    mutateGraphQL,
} from 'common/util/query';
import {
    node,
    nodeWithArgs,
    toQuery,
    toMutation,
} from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';

export const ACTIONS = {
    SUBMIT_EVENT_SIGN_TASK: 'SUBMIT_EVENT_SIGN_TASK',
    GET_EVENT_SIGNATURE_REQUEST: 'GET_EVENT_SIGNATURE_REQUEST',
    UNLOAD_EVENT_SIGNATURE_REQUEST: 'UNLOAD_EVENT_SIGNATURE_REQUEST',
    CANCEL_EVENT_SIGNATURE: 'CANCEL_EVENT_SIGNATURE',
};

export function cancelEventSignature(taskIdFrom, evenIdFrom, eventInsitutionId) {
    return async (dispatch, getState) => {
        const storeState = getState();

        const task = lodash.get(storeState, 'form.signatureRequest');
        const taskId = taskIdFrom || task.id;
        const event = task && (task.event || task.customEvent);
        const eventId = evenIdFrom || event.id;
        const institutionId = eventInsitutionId || event.institutionId;

        const mutation = nodeWithArgs('cancelEventSignature', {
            input: {
                eventId,
                taskId,
                institutionId,
            }
        });
        const response = await mutateGraphQL(toMutation(mutation));

        if (response && response.errors) {
            dispatch(addApplicationMessage('error', 'Failed to cancel event signature'));
        } else {
            dispatch(getEventTask(taskId));
            dispatch(addApplicationMessage('success', 'Event signature has been canceled.'));
        }
    };
}

export function signEventTask({
    eventId,
    taskId,
    institutionId,
    signingToken,
}
) {
    const query = toMutation(nodeWithArgs('signEvent', {
        input: {
            statement: 'Please approve these event details',
            eventId,
            taskId,
            institutionId,
            signingToken,
        }
    }));

    return async dispatch => {
        const {
            errors,
            data,
        } = await mutateGraphQL(query);
        if (errors) {
            dispatch(addApplicationMessage('error', 'Failed to sign task'));
        } else {
            dispatch(addApplicationMessage('success', 'Event task signed'));
            dispatch({
                type: ACTIONS.SUBMIT_EVENT_SIGN_TASK,
                payload: {
                    success: data.signEvent,
                },
            });
        }
    };
}

export function getEventTask(eventTaskId) {
    const query = toQuery(nodeWithArgs('signatureRequest', {
        signatureRequestId: eventTaskId
    }, [
        'id',
        'status',
        node('createdBy', [
            'id',
            'displayName',
        ]),
        node('requestedFrom', [
            'id',
            'displayName',
            'emailAddress',
        ]),
        node('event', [
            'id',
            'eventType',
            'monitorVisitType',
            'dateOfVisit',
            'institutionId',
            'irbApprovalDate',
            'icfType',
            'icfLanguage',
            'reconsentRequired',
            'sponsorVersion',
            'siteVersion',
            'protocolVersion',
            'summaryOfChanges',
            node('monitor', [
                'displayName',
            ]),
        ]),
        node('customEvent', [
            'id',
            'institutionId',
            node('eventType', [
                'id',
                'displayName',
                'name',
            ]),
            node('primaryDate', [
                'name',
                'displayName',
                'value',
                'valueType',
                'view'
            ]),
            node('fields', [
                'id',
                'name',
                'displayName',
                'value',
                'valueType',
                'view'
            ]),
        ]),
        'sentDate',
        'binderName',
    ]));

    return async dispatch => {
        const {
            errors,
            data,
        } = await queryGraphQL(query);

        if (errors) {
            dispatch(addApplicationMessage('error', 'Failed to load the event task'));
        }
        else {
            const { signatureRequest } = data;
            dispatch({
                type: ACTIONS.GET_EVENT_SIGNATURE_REQUEST,
                payload: signatureRequest,
            });
            dispatch({
                type: 'SET_TASK_FOR_DETAIL_DISPLAY',
                payload: signatureRequest,
            });
        }
    };
}

export function unloadEventTask() {
    return dispatch => {
        dispatch({
            type: ACTIONS.UNLOAD_EVENT_SIGNATURE_REQUEST,
        });
    };
}
